import { Link } from "react-scroll";
import React from "react";

function Footer() {
  return (
    <footer className="footer--container">
      <div className="footer--link--container">
        <div>
        </div>
        <div className="footer--social--icon">
          <ul>
            <li>
              <a
                href="https://www.linkedin.com/in/guillermo-kramsky-iturbide-5a9ba3246"
                className="navbar--content"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 33 33"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.33341 4.65479H26.0001C27.4729 4.65479 28.6667 5.84869 28.6667 7.32145V25.9881C28.6667 27.4609 27.4729 28.6548 26.0001 28.6548H7.33341C5.86065 28.6548 4.66675 27.4609 4.66675 25.9881V7.32145C4.66675 5.84869 5.86065 4.65479 7.33341 4.65479ZM11.3334 24.6548C11.7016 24.6548 12.0001 24.3563 12.0001 23.9881V14.6548C12.0001 14.2867 11.7016 13.9881 11.3334 13.9881H9.33342C8.96523 13.9881 8.66675 14.2867 8.66675 14.6548V23.9881C8.66675 24.3563 8.96523 24.6548 9.33342 24.6548H11.3334ZM10.3334 12.6548C9.22884 12.6548 8.33341 11.7594 8.33341 10.6548C8.33341 9.55021 9.22884 8.65479 10.3334 8.65479C11.438 8.65479 12.3334 9.55021 12.3334 10.6548C12.3334 11.7594 11.438 12.6548 10.3334 12.6548ZM24.0001 24.6548C24.3682 24.6548 24.6667 24.3563 24.6667 23.9881V17.8548C24.7101 15.7359 23.1435 13.9275 21.0401 13.6681C19.5694 13.5338 18.1445 14.2207 17.3334 15.4548V14.6548C17.3334 14.2867 17.0349 13.9881 16.6667 13.9881H14.6667C14.2986 13.9881 14.0001 14.2867 14.0001 14.6548V23.9881C14.0001 24.3563 14.2986 24.6548 14.6667 24.6548H16.6667C17.0349 24.6548 17.3334 24.3563 17.3334 23.9881V18.9881C17.3334 17.8836 18.2289 16.9881 19.3334 16.9881C20.4379 16.9881 21.3334 17.8836 21.3334 18.9881V23.9881C21.3334 24.3563 21.6319 24.6548 22.0001 24.6548H24.0001Z"
                    fill="white"
                  />
                </svg>
              </a>
            </li>
            <li>
            <a
              href="https://github.com/memokr"
              className="navbar--content"
              target="_blank"
              rel="noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12 0.297C5.37 0.297 0 5.667 0 12.297C0 17.493 3.438 21.898 8.207 23.435C8.807 23.548 9.047 23.174 9.047 22.854C9.047 22.575 9.037 21.794 9.03 20.777C5.672 21.45 4.968 19.493 4.968 19.493C4.406 18.121 3.6 17.776 3.6 17.776C2.457 17.07 3.684 17.087 3.684 17.087C4.94 17.175 5.598 18.387 5.598 18.387C6.684 20.287 8.547 19.784 9.297 19.497C9.42 18.704 9.747 18.147 10.113 17.87C7.555 17.59 4.898 16.513 4.898 11.773C4.898 10.454 5.385 9.37 6.17 8.53C6.032 8.234 5.615 6.95 6.29 5.237C6.29 5.237 7.303 4.917 9.036 6.15C9.977 5.895 10.977 5.766 11.977 5.76C12.977 5.766 13.977 5.895 14.919 6.15C16.653 4.917 17.665 5.237 17.665 5.237C18.34 6.95 17.923 8.234 17.785 8.53C18.57 9.37 19.058 10.454 19.058 11.773C19.058 16.527 16.4 17.582 13.837 17.856C14.29 18.247 14.693 19.027 14.693 20.177C14.693 21.85 14.677 22.987 14.677 22.854C14.677 23.174 14.917 23.552 15.523 23.435C20.29 21.898 23.727 17.493 23.727 12.297C23.727 5.667 18.358 0.297 12 0.297Z"
                  fill="white"
                />
              </svg>
            </a>
          </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
